module.exports = __webpack_public_path__ + "img/chinesecompany102.68e0be26.png";